import { createSelector } from 'reselect'
import Immutable from 'immutable'
import { deserializeQueryString } from '../../utils/urlManager'

export const selectPlanSelectionDomain = (state) => state.get('planSelection')
const selectPlanDomain = (state) => state.get('plan')
const selectProps = (state, props) => props

export const makeSelectError = () =>
  createSelector(selectPlanSelectionDomain, (substate) => substate.get('error'))

export const makeSelectLoading = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('loading')
  )
export const makeSelectFilter = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('filter')
  )

export const makeSelectCreateFolderError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('createFolderError')
  )

export const makeSelectFolderCreated = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('folderCreated')
  )

export const makeSelectLastCreatedFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('lastCreatedFolder')
  )

export const makeSelectCreateFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('createFolder')
  )

export const makeSelectMovePlanError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('movePlanError')
  )

export const makeSelectPlanMoved = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('planMoved')
  )

export const makeSelectMovePlan = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('movePlan')
  )

export const makeSelectMoveFolderError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveFolderError')
  )

export const makeSelectFolderMoved = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('folderMoved')
  )

export const makeSelectMoveFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveFolder')
  )
export const makeSelectProjectId = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    if (substate.get('projectId')) {
      return substate.get('projectId')
    }

    const projectIdFromPath = window.location.pathname
      .replace('/project/', '')
      .substring(0, 36)
    if (
      projectIdFromPath.match(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      )
    ) {
      return projectIdFromPath
    }
    return undefined
  })
export const makeSelectProjectName = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('projectName')
  )

export const makeSelectSortBy = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('sortBy')
  )

export const makeSelectFolderBatchCount = () =>
  createSelector(
    selectPlanSelectionDomain,
    (substate) => substate.get('folderBatchSelection').size
  )

export const makeSelectFoldersInBatch = () =>
  createSelector(selectPlanSelectionDomain, selectProps, (substate, props) =>
    substate.getIn(['folderBatchSelection', props.folder.id])
  )

export const makeSelectMoveFolderBatchError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveFolderBatchError')
  )
export const makeSelectFolderBatchMoved = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('folderBatchMoved')
  )
export const makeSelectMoveFolderBatchLoading = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveFolderBatchLoading')
  )

export const makeSelectPlanBatchCount = () =>
  createSelector(
    selectPlanSelectionDomain,
    (substate) => substate.get('planBatchSelection').size
  )

export const makeSelectPlanInBatch = () =>
  createSelector(selectPlanSelectionDomain, selectProps, (substate, props) =>
    substate.getIn(['planBatchSelection', props.plan?.id])
  )

export const makeSelectMovePlanBatchError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('movePlanBatchError')
  )
export const makeSelectPlanBatchMoved = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('planBatchMoved')
  )
export const makeSelectMovePlanBatchLoading = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('movePlanBatchLoading')
  )

export const makeSelectUpdatingFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('updatingFolder')
  )

export const makeSelectRenamingFolder = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('renamingFolder')
  )

export const makeSelectUpdateFolderError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('updateFolderError')
  )

export const makeSelectCanCreatePlan = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('canCreatePlan')
  )

export const deleteEmptyFolderError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('deleteEmptyFolderError')
  )

export const makeSelectGetPlansTreeCancelToken = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansTreeCancelToken')
  )
export const makeSelectPlansSort = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansSort')
  )
export const makeSelectPlansStateFilter = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansStateFilter')
  )
export const makeSelectPlansSearch = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansSearch')
  )

export const makeSelectTilePlans = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    const query = deserializeQueryString(location.search)
    const folderId = query.folder
    if (folderId && substate.hasIn(['planFolders', folderId])) {
      const plans = substate.getIn(['planFolders', folderId]).toJS()
      plans.content = Object.values(plans.content)
      return plans
    }
    if (!folderId && substate.has('rootPlansObject')) {
      const plans = substate.get('rootPlansObject').toJS()
      plans.content = Object.values(plans.content)
      return plans
    }
    return undefined
  })

export const makeSelectTileFolderInfo = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    const query = deserializeQueryString(location.search)
    const folderId = query.folder
    if (folderId && substate.hasIn(['planFolders', folderId])) {
      const plans = substate.getIn(['planFolders', folderId]).toJS()
      return {
        parentId: plans.parentId,
        name: plans.name,
        id: plans.id
      }
    }
    return undefined
  })

export const makeSelectRootPlans = () =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    if (substate.has('rootPlansObject')) {
      const plans = substate.get('rootPlansObject').toJS()
      plans.content = Object.values(plans.content)
      return plans
    }
    return undefined
  })
export const makeSelectPlanToBe = () =>
  createSelector(
    selectPlanSelectionDomain,
    selectPlanDomain,
    (substate, planState) =>
      substate
        .getIn(['rootPlansObject', 'content', planState.get('currentPlanId')])
        ?.toJS()
  )
export const makeSelectGetRootPlansError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('getRootPlansError')
  )
export const makeSelectGettingRootPlans = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('gettingRootPlans')
  )
export const makeSelectGettingFolderPlans = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('gettingFolderPlans')
  )
export const makeSelectFolderPlans = (folderId) =>
  createSelector(selectPlanSelectionDomain, selectProps, (substate, props) => {
    const fId = props?.folder.id ?? folderId

    if (substate.hasIn(['planFolders', fId])) {
      let plans = substate.getIn(['planFolders', fId])
      if (Immutable.Iterable.isIterable(plans)) {
        plans = plans.toJS()
        plans.content = Object.values(plans.content)

        return plans
      }
    }

    return undefined
  })
export const makeSelectGetFolderPlansError = () =>
  createSelector(selectPlanSelectionDomain, selectProps, (substate, props) =>
    substate.get(`getFolderPlansError${props.folder.id}`)
  )

export const makeSelectAllPlanInBatch = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('planBatchSelection').toArray()
  )
export const makeSelectPlansInBatchId = () =>
  createSelector(selectPlanSelectionDomain, (substate) => [
    ...substate.get('planBatchSelection').keys()
  ])
export const makeSelectAllFoldersInBatch = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('folderBatchSelection').toArray()
  )
export const makeSelectMoveItemsBatchLoading = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveItemsBatchLoading')
  )

export const makeSelectMoveItemsBatchError = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('moveItemsBatchError')
  )
export const makeSelectItemsBatchMoved = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('itemsBatchMoved')
  )

export const makeSelectRootPlansTimestamp = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('rootPlansTimestamp')
  )

export const makeSelectFolderTimestamp = () =>
  createSelector(selectPlanSelectionDomain, selectProps, (substate, props) =>
    substate.getIn(['planFolderTimestamps', props.folder.id])
  )
export const makeSelectPlansQuickStatus = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansQuickStatus')
      ? substate.get('plansQuickStatus').content
      : undefined
  )
export const makeSelectGettingPlansQuickStatus = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('gettingPlansQuickStatus')
  )
export const makeSelectPlansSyncStatus = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('plansSyncStatus')
  )
export const makeSelectFoldersSyncStatus = () =>
  createSelector(selectPlanSelectionDomain, (substate) =>
    substate.get('foldersSyncStatus')
  )

export const makeSelectTilePlansError = (folderId) =>
  createSelector(selectPlanSelectionDomain, (substate) => {
    if (folderId && substate.hasIn(['planFolders', folderId])) {
      return substate.get(`getFolderPlansError${folderId}`)
    }
    return substate.get('getRootPlansError')
  })
